import { pontosNoMundo } from './ancoragem'
import type { CenaTabletop, ReferenciaPonto, VetorTabletop } from './tipos'

/** Quão perto do raio do mouse um ponto precisa estar, perto da câmera, e quanto isso cresce com a distância. */
const TOLERANCIA_BASE_M = 0.08
const TOLERANCIA_POR_METRO = 0.02

export interface PontoSobOMouse {
  readonly referencia: ReferenciaPonto
  readonly mundo: VetorTabletop
}

/**
 * O ponto de ancoragem mais perto do raio do mouse (origem + direção unitária),
 * para soltar nele uma ponta ou um ponto de corda arrastado. A tolerância cresce
 * com a distância à câmera, para o ponto longe ser tão fácil de pegar quanto o
 * perto. Entre os candidatos vence o mais perto do mouse na tela, e não o mais
 * longe da câmera. Pontos de objetos ocultos não contam.
 */
export function pontoMaisPertoDoRaio(
  cena: CenaTabletop,
  origem: VetorTabletop,
  direcao: VetorTabletop,
  excluir: ReadonlySet<string> = new Set(),
): PontoSobOMouse | null {
  let melhor: (PontoSobOMouse & { custo: number }) | null = null
  for (const objeto of cena.objetos) {
    if (objeto.oculto) continue
    for (const p of pontosNoMundo(objeto)) {
      if (excluir.has(`${objeto.id}:${p.id}`)) continue
      const v: VetorTabletop = [p.mundo[0] - origem[0], p.mundo[1] - origem[1], p.mundo[2] - origem[2]]
      const t = v[0] * direcao[0] + v[1] * direcao[1] + v[2] * direcao[2]
      if (t <= 0) continue
      const perpendicular = Math.hypot(v[0] - direcao[0] * t, v[1] - direcao[1] * t, v[2] - direcao[2] * t)
      if (perpendicular > TOLERANCIA_BASE_M + TOLERANCIA_POR_METRO * t) continue
      // vale a distância ao mouse NA TELA (o ângulo com o raio), não a distância no espaço:
      // um ponto longe, na mesma linha de visão, não ganha de um ponto perto
      const custo = perpendicular / t + t * 1e-5
      if (!melhor || custo < melhor.custo) melhor = { referencia: { idObjeto: objeto.id, idPonto: p.id }, mundo: p.mundo, custo }
    }
  }
  return melhor ? { referencia: melhor.referencia, mundo: melhor.mundo } : null
}
